import { getPath } from '@/router/common'

const baseUrl = {
  title: '询价调车',
  path: 'xjdcContainer'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'xjdcContainer_index',
    component: () =>
      import(
        /* webpackChunkName: "xjdcContainer_index" */ '@/views/xjdcContainer/index.vue'
      ),
    meta: {
      title: '询价调车'
    }
  }
]
